var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.1716 0.464318L36.3536 3.6463C36.5488 3.84156 36.5488 4.15814 36.3536 4.3534L33.1716 7.53539C32.9763 7.73065 32.6597 7.73065 32.4645 7.53539C32.2692 7.34012 32.2692 7.02354 32.4645 6.82828L34.7929 4.49985L0 4.49986V3.49986L34.7929 3.49985L32.4645 1.17142C32.2692 0.976162 32.2692 0.65958 32.4645 0.464318C32.6597 0.269056 32.9763 0.269056 33.1716 0.464318Z","fill":"#37463E"}));
}

ArrowInline.defaultProps = {"width":"37","height":"8","viewBox":"0 0 37 8","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
